import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex h-full items-center justify-center p-4 sm:p-8"
}
const _hoisted_2 = {
  key: 0,
  class: "flex h-full items-center justify-center p-8"
}
const _hoisted_3 = {
  key: 1,
  class: "flex h-full items-center justify-center p-8"
}
const _hoisted_4 = {
  key: 0,
  class: "pt-4"
}

import { computed, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'

import FranchiseMenuControls from '@/components/franchise/FranchiseMenuControls.vue'
import FranchiseMenuSetupCard from '@/components/franchise/FranchiseMenuSetupCard.vue'
import FranchiseMerchantSwitcher from '@/components/franchise/FranchiseMerchantSwitcher.vue'
import EmptyState from '@/components/neue/EmptyState.vue'
import NeueLoading from '@/components/neue/NeueLoading.vue'
import SegmentedControl from '@/components/neue/SegmentedControl.vue'
import StoreAvailability from '@/components/neue/StoreAvailability.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import SecondaryTop from '@/components/SecondaryTop.vue'
import { blueprintIdOf } from '@/helpers/franchiseMerchant'
import api from '@/store/api'


export default {
  __name: 'FranchiseAvailability',
  setup(__props) {

const store = useStore()
const activeMerchantId = computed(() => store.state.activeFranchiseMerchantId)
// With no location chosen and no franchise menu yet, the switcher reads "Franchise menu" and this offers to set it up.
const blueprintId = computed(() => blueprintIdOf(store.state))

const stores = ref([])
const selectedStoreId = ref(null)
const loading = ref(false)
const loadFailed = ref(false)

const storeOptions = computed(() => stores.value.map(item => ({ value: item.id, name: item.attributes.store_name })))

// The object cache can still hold another franchisee's stores from a late response,
// so the list comes from this response alone, in the order the server sent it.
const activeStoresIn = response => (response?.data?.data ?? []).filter(item => item.attributes?.is_active !== false)

const fetchStores = async () => {
  try {
    return { stores: activeStoresIn(await api.call('GET', 'stores?included=none')) }
  } catch {
    return { failed: true }
  }
}

const loadStores = async () => {
  stores.value = []
  selectedStoreId.value = null
  loadFailed.value = false
  const merchantId = activeMerchantId.value
  if (!merchantId) return
  loading.value = true
  const result = await fetchStores()
  // A quicker switch to another franchisee owns the page now, and its own load finishes it.
  if (merchantId !== activeMerchantId.value) return
  stores.value = result.stores ?? []
  loadFailed.value = !!result.failed
  selectedStoreId.value = stores.value[0]?.id ?? null
  loading.value = false
}

onMounted(loadStores)
watch(activeMerchantId, loadStores)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(SecondaryTop, { text: "Product availability" }, {
        right: _withCtx(() => [
          _createVNode(FranchiseMenuControls),
          _createVNode(FranchiseMerchantSwitcher, {
            "include-all": false,
            "include-blueprint": ""
          })
        ]),
        _: 1
      })
    ]),
    main: _withCtx(() => [
      (!activeMerchantId.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!blueprintId.value)
              ? (_openBlock(), _createBlock(FranchiseMenuSetupCard, { key: 0 }))
              : (_openBlock(), _createBlock(EmptyState, {
                  key: 1,
                  plural: "stores",
                  description: "Choose a location to see its product availability"
                }))
          ]))
        : (_openBlock(), _createBlock(NeueLoading, {
            key: 1,
            loading: loading.value,
            class: "h-full"
          }, {
            default: _withCtx(() => [
              (loadFailed.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(EmptyState, {
                      plural: "stores",
                      description: "Could not load this location's stores. Try again."
                    })
                  ]))
                : (!loading.value && !stores.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(EmptyState, {
                        plural: "stores",
                        description: "This location has no stores yet"
                      })
                    ]))
                  : (selectedStoreId.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (stores.value.length > 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              _createVNode(SegmentedControl, {
                                modelValue: selectedStoreId.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((selectedStoreId).value = $event)),
                                options: storeOptions.value
                              }, null, 8, ["modelValue", "options"])
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(), _createBlock(StoreAvailability, {
                          id: selectedStoreId.value,
                          key: selectedStoreId.value
                        }, null, 8, ["id"]))
                      ], 64))
                    : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading"]))
    ]),
    _: 1
  }))
}
}

}